module.exports = __webpack_public_path__ + "static/media/export-example.ca90c6ac.svg";